import Ctx from 'pages-components/Ctx';

import type { ITariffCardReactModel } from '../types';

export const simpleTariffCardAdapter = (
  props: ITariffCardReactModel & { setESimOpenModal: () => void },
) => {
  const {
    alias,
    benefits,
    pageTitle,
    familyNavigation,
    productTypeTitle,
    pageTitleIcon,
    discountValue,
  } = props.data || {};

  // Если есть бэйдж скидки;
  let discountText = null;

  // Устанавливаем подзаголовок страницы;
  let subTitleText = discountValue ? Ctx.tariff.subTitle.discount : Ctx.tariff.subTitle.regular;

  // Если это тариф со скидкой + бэйдж;
  if (productTypeTitle) {
    subTitleText = productTypeTitle.text;
    discountText = productTypeTitle.discount;
  }

  return {
    alias,
    // Подсвечивать заголовок ораньжевым если есть скидка или бэйджи тарифа со скидкой;
    isBurnSubTitle: Boolean(discountValue || discountText),
    discountText,
    benefits: benefits && benefits.length > 0 ? benefits : null,
    familyNavigation: familyNavigation && familyNavigation.length > 1 ? familyNavigation : null,
    pageTitle,
    subTitleText,
    pageTitleIcon,
    setESimOpenModal: props.setESimOpenModal,
  };
};
